import { atom } from "jotai";
import { RouteProps } from "react-router-dom";

export const preloadableRoutesAtom = atom<RouteProps[]>([]);
